<template>
	<div>
		<van-nav-bar
			title="书柜绑定"
			left-text="返回"
			left-arrow
			@click-left="onClickLeft"
		/>
		<van-form @submit="onSubmit">
			<van-row>
				<van-col span="24">
					<van-field
						readonly
						clickable
						name="picker"
						:value="areaName"
						label="* 地区"
						placeholder="点击选择地区"
						@click="showArea = true"
					/>
					<van-popup v-model="showArea" position="bottom">
						<van-area
							title="选择书柜所在地区"
							:area-list="areaList"
							@cancel="showArea = false"
							@confirm="onConfirmArea"
							:columns-placeholder="['请选择省', '请选择市', '请选择区/县']"
						/>
					</van-popup>
				</van-col>
			</van-row>

			<van-row>
				<van-col span="24">
					<van-field
						readonly
						clickable
						name="picker"
						:value="schoolName"
						label="* 书柜"
						placeholder="点击选择书柜"
						@click="showSchool = true"/><van-popup
						v-model="showSchool"
						position="bottom"
					>
						<van-picker
							show-toolbar
							:columns="schools"
							value-key="schoolName"
							@confirm="onConfirmSchool"
							@cancel="showSchool = false"
						/> </van-popup
				></van-col>
			</van-row>
			<van-row>
				<van-col span="24">
					<van-field
						readonly
						clickable
						name="picker"
						:value="className"
						label="* 所属"
						placeholder="点击选择所属"
						@click="showClass = true"/><van-popup
						v-model="showClass"
						position="bottom"
					>
						<van-picker
							show-toolbar
							value-key="className"
							:columns="classes"
							@confirm="onConfirmClass"
							@cancel="showClass = false"
						/> </van-popup
				></van-col>
			</van-row>
			<van-row>
				<van-col span="24">
					<van-field
						v-model="code"
						name="studentName"
						label="* 姓名"
						placeholder="姓名"
				/></van-col>
			</van-row>

			<van-row>
				<van-col span="18" offset="3" class="btn_register">
					<van-button block type="primary" native-type="submit">
						关联
					</van-button></van-col
				>
			</van-row>
		</van-form>
	</div>
</template>

<script>
import {
	Row,
	Col,
	Form,
	NavBar,
	Field,
	Button,
	Picker,
	Popup,
	Area,
	Toast,
} from "vant";
import { Get, Post } from "@/utils/Api";
import { AreaList } from "@/component/Area";

export default {
	components: {
		[Row.name]: Row,
		[Col.name]: Col,
		[Form.name]: Form,
		[Field.name]: Field,
		[NavBar.name]: NavBar,
		[Button.name]: Button,
		[Picker.name]: Picker,
		[Popup.name]: Popup,
		[Area.name]: Area,
	},
	data() {
		return {
			code: "",
			schools: null,
			classes: null,
			showArea: false,
			showSchool: false,
			showClass: false,
			areaList: AreaList,
			areaName: null,
			province: null,
			city: null,
			area: null,
			schoolId: null,
			schoolName: null,
			classId: null,
			className: null,
		};
	},
	created: function() {
		console.log("CREATED");
	},
	mounted: function() {
		console.log("MOUNTED");
	},
	methods: {
		onConfirm(value) {
			this.value = value;
			this.showPicker = false;
		},
		onSubmit(values) {
			console.log("submit", values);

			console.log(this.classId, this.code);

			var openId = localStorage.getItem("openId");

			Post(
				"bindStudent",
				{
					schoolId: this.schoolId,
					classId: this.classId,
					realName: this.code,
					code: this.code,
					openId: openId,
				},
				(res) => {
					var r = res.data;
					if (r.success) {
						Toast.success(r.msg);
						this.$router.push({
							path: "/user",
						});
					} else {
						Toast.fail(r.msg);
					}
					console.log("绑定学生", res.data);
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
		onConfirmArea(value) {
			var a = "";
			this.province = this.city = this.area = null;
			for (var i = 0, MAX = value.length; i < MAX; i++) {
				switch (i) {
					case 0:
						this.province = value[i].name;
						break;
					case 1:
						this.city = value[i].name;
						break;
					case 2:
						this.area = value[i].name;
						break;
				}
				a += value[i].name + " ";
			}

			this.areaName = a;
			this.showArea = false;
			this.schoolName = null;

			Get(
				"school/queryAll",
				{
					province: this.province,
					city: this.city,
					area: this.area,
				},
				(res) => {
					console.log("load school", res.data.data);
					this.schools = res.data.data;
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
		onConfirmSchool(value) {
			console.log(value);
			this.schoolId = value.id;
			this.schoolName = value.schoolName;
			this.showSchool = false;

			Get(
				"class/queryAll",
				{
					schoolId: this.schoolId,
				},
				(res) => {
					console.log("load grade", res.data.data);
					this.classes = res.data.data;
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
		onConfirmClass(value) {
			console.log(value);
			this.classId = value.id;
			this.className = value.className;
			this.showClass = false;
		},
		onClickLeft: function() {
			this.$router.push({ name: "user" });
		},
	},
};
</script>

<style scoped>
.btn_register {
	margin-top: 20px;
}
</style>
